import type { RadioButtonChangeEvent } from "primereact/radiobutton";
import { useId } from "react";

import { useRadioGroupContext } from "../../radio-group.context";
import type { RadioGroupItemProps, RadioGroupItemViewProps } from "./types-item";

/** ViewModel do RadioGroup.Item: `inputId`, `checked` e o handler que emite o valor do item; sem JSX. */
export function useRadioGroupItem({
  value,
  label,
  description,
  disabled: itemDisabled = false,
  testId,
  id,
  ...rest
}: RadioGroupItemProps): RadioGroupItemViewProps {
  const group = useRadioGroupContext();
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const labelId = `${inputId}-label`;
  const descriptionId = `${inputId}-description`;
  const disabled = group.disabled || itemDisabled;
  const itemTestId = testId ?? (group.testId ? `${group.testId}-item-${String(value)}` : undefined);

  return {
    label,
    labelId,
    description,
    descriptionId,
    disabled,
    classNames: group.classNames,
    rest,
    testId: itemTestId,
    partTestId: (part: string) => (itemTestId ? `${itemTestId}-${part}` : undefined),
    radioProps: {
      inputId,
      name: group.name,
      value,
      checked: group.value === value,
      disabled,
      invalid: group.invalid,
      "aria-labelledby": labelId,
      "aria-describedby": description ? descriptionId : undefined,
      onChange: (_event: RadioButtonChangeEvent) => {
        if (!disabled) group.select(value);
      },
    },
  };
}
